import {
  INTEGRATIONS_CLEAR_STATE,
  INTEGRATIONS_CLOSE_CONNECT_FORM,
  INTEGRATIONS_CLOSE_DISCONNECT_MODAL,
  INTEGRATIONS_CLOSE_RECONFIGURE_FORM,
  INTEGRATIONS_CLOSE_REPLACE_MODAL,
  INTEGRATIONS_FETCH_FAILURE,
  INTEGRATIONS_FETCH_REQUEST,
  INTEGRATIONS_FETCH_SUCCESS,
  INTEGRATIONS_OPEN_CONNECT_FORM,
  INTEGRATIONS_OPEN_DISCONNECT_MODAL,
  INTEGRATIONS_OPEN_RECONFIGURE_FORM,
  INTEGRATIONS_OPEN_REPLACE_MODAL,
  INTEGRATIONS_SUBMIT_FAILURE,
  INTEGRATIONS_SUBMIT_REQUEST,
  INTEGRATIONS_SUBMIT_SUCCESS,
  INTEGRATIONS_VALIDATION_MARK_INVALID
} from './integrationsActions'

const INITIAL_STATE = {
  integration: null,
  loading: false,
  loaded: false,
  error: null,

  validationStatus: null,

  isConnectFormOpen: false,
  connectToolCode: null,

  isReconfigureFormOpen: false,

  isReplaceModalOpen: false,
  replaceTargetToolCode: null,

  isDisconnectModalOpen: false,

  isSubmitting: false,
  submitActionType: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INTEGRATIONS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case INTEGRATIONS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        integration: action.payload || null,
        validationStatus: null,
        isConnectFormOpen: false,
        connectToolCode: null,
        isReconfigureFormOpen: false,
        isReplaceModalOpen: false,
        replaceTargetToolCode: null,
        isDisconnectModalOpen: false
      }

    case INTEGRATIONS_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload || null
      }

    case INTEGRATIONS_OPEN_CONNECT_FORM:
      return {
        ...state,
        isConnectFormOpen: true,
        connectToolCode: action.payload || null,
        isReconfigureFormOpen: false
      }

    case INTEGRATIONS_CLOSE_CONNECT_FORM:
      return {
        ...state,
        isConnectFormOpen: false,
        connectToolCode: null
      }

    case INTEGRATIONS_OPEN_RECONFIGURE_FORM:
      return {
        ...state,
        isReconfigureFormOpen: true,
        isConnectFormOpen: false,
        connectToolCode: null
      }

    case INTEGRATIONS_CLOSE_RECONFIGURE_FORM:
      return {
        ...state,
        isReconfigureFormOpen: false
      }

    case INTEGRATIONS_OPEN_REPLACE_MODAL:
      return {
        ...state,
        isReplaceModalOpen: true,
        replaceTargetToolCode: action.payload || null
      }

    case INTEGRATIONS_CLOSE_REPLACE_MODAL:
      return {
        ...state,
        isReplaceModalOpen: false,
        replaceTargetToolCode: null
      }

    case INTEGRATIONS_OPEN_DISCONNECT_MODAL:
      return {
        ...state,
        isDisconnectModalOpen: true
      }

    case INTEGRATIONS_CLOSE_DISCONNECT_MODAL:
      return {
        ...state,
        isDisconnectModalOpen: false
      }

    case INTEGRATIONS_SUBMIT_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        submitActionType: action.payload || null,
        error: null
      }

    case INTEGRATIONS_SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        submitActionType: null,
        integration:
          action.payload && Object.prototype.hasOwnProperty.call(action.payload, 'integration')
            ? action.payload.integration
            : state.integration,
        validationStatus:
          action.payload && Object.prototype.hasOwnProperty.call(action.payload, 'validationStatus')
            ? action.payload.validationStatus
            : state.validationStatus,
        isConnectFormOpen: false,
        connectToolCode: null,
        isReconfigureFormOpen: false,
        isReplaceModalOpen: false,
        replaceTargetToolCode: null,
        isDisconnectModalOpen: false
      }

    case INTEGRATIONS_SUBMIT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        submitActionType: null
      }

    case INTEGRATIONS_VALIDATION_MARK_INVALID:
      return {
        ...state,
        validationStatus: 'invalid'
      }

    case INTEGRATIONS_CLEAR_STATE:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}